import { staticText } from '../../../utils/translations/staticText';

// Keys are named by role; call sites read them only behind Moneymax checks (CMS-2047).
const vehicleTranslations = {
  select_make: {
    _: 'Select make',
  },
  select_model: {
    _: 'Select model',
  },
  select_year: {
    _: 'Select year',
  },
  select_variant: {
    _: 'Select variant',
  },
  select_your_make: {
    _: 'Please select your make',
  },
  select_your_model: {
    _: 'Please select your model',
  },
  select_your_year: {
    _: 'Please select your year of manufacture',
  },
  select_your_variant: {
    _: 'Please select your variant',
  },
  enter_vehicle_details_for_premium: {
    _: 'Enter your vehicle details to see your premium',
  },
};

export const VEHICLE_TRANSLATIONS = staticText(vehicleTranslations);
